import React, { useState, useEffect } from 'react'
import { Link, NavLink } from 'react-router-dom';
import config from '../../config';
import LeftSidebar from '../Common/LeftSidebar';
import Loader from '../Common/Loader';
import RightIconMenu from '../Common/RightIconMenu';
import RightSidebar from '../Common/RightSidebar';

import {username,role} from '../Actions/AuthAction';



const EmployerDashboard = (props) => {




    return (
        <React.Fragment>
                
                            
                           
                <div class="row mt-5">
                                <div class="col-xl-3 col-md-6">
                                    <div class="card-custom card mb-4">
                                        <div class="card-body d-flex justify-content-between">
                                            <h5>Universities
                                                <span class="d-block text-danger mt-4">20</span>
                                            </h5>
                                            <h2 class="text-danger dashboardicon"> <i class="d-block text-danger dashboardiconimg fas fa-university"></i></h2>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-3 col-md-6">
                                    <div class="card-custom card mb-4">
                                        <div class="card-body d-flex justify-content-between">
                                            <h5>Institutions
                                                <span class="d-block text-danger mt-4">1</span>
                                            </h5>
                                            <h2 class="text-danger dashboardicon"> <i class="d-block text-danger dashboardiconimg fas fa-building"></i></h2>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-3 col-md-6">
                                    <div class="card-custom card mb-4">
                                        <div class="card-body d-flex justify-content-between">
                                            <h5>Recruiters
                                                <span class="d-block text-danger mt-4">3</span>
                                            </h5>
                                            <h2 class="text-danger dashboardicon"> <i class="d-block text-danger dashboardiconimg fas fa-user-secret"></i></h2>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-3 col-md-6">
                                    <div class="card-custom card mb-4">
                                        <div class="card-body d-flex justify-content-between">
                                            <h5>Employers
                                                <span class="d-block text-danger mt-4">4</span>
                                            </h5>
                                            <h2 class="text-danger dashboardicon"> <i class="d-block text-danger dashboardiconimg fas fa-graduation-cap"></i></h2>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-3 col-md-6">
                                    <div class="card-custom card mb-4">
                                        <div class="card-body d-flex justify-content-between">
                                            <h5>Candidates
                                                <span class="d-block text-danger mt-4">4000</span>
                                            </h5>
                                            <h2 class="text-danger dashboardicon"> <i class="d-block text-danger dashboardiconimg fas fa-users"></i></h2>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card mb-4">
                                <div class="card-header">
                                    Table
                                </div>
                                <div class="card-body">
                                    <div class="table-responsive">
                                        <table class="table table-bordered" width="100%" cellspacing="0">
                                            <thead>
                                                <tr>
                                                    <th>Name</th>
                                                    <th>Position</th>
                                                    <th>Office</th>
                                                    <th>Age</th>
                                                    <th>Start date</th>
                                                    <th>Salary</th>
                                                </tr>
                                            </thead>
                                            <tbody>                                               
                                                <tr>
                                                    <td>Shad Decker</td>
                                                    <td>Regional Director</td>
                                                    <td>Edinburgh</td>
                                                    <td>51</td>
                                                    <td>2008/11/13</td>
                                                    <td>$183,000</td>
                                                </tr>
                                                <tr>
                                                    <td>Michael Bruce</td>
                                                    <td>Javascript Developer</td>
                                                    <td>Singapore</td>
                                                    <td>29</td>
                                                    <td>2011/06/27</td>
                                                    <td>$183,000</td>
                                                </tr>
                                                <tr>
                                                    <td>Donna Snider</td>
                                                    <td>Customer Support</td>
                                                    <td>New York</td>
                                                    <td>27</td>
                                                    <td>2011/01/25</td>
                                                    <td>$112,000</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div  class="d-flex justify-content-between">
                                        <h6>Showing 1-10 results from 50</h6>
                                        <ul class="d-flex justify-content-between list-unstyled pagination">
                                            <li class="px-1"><a href="#"><i class="fa fa-angle-double-left" aria-hidden="true"></i></a></li>       
                                            <li class="px-1 active"><a href="#">1</a></li>                                            
                                            <li class="px-1"><a href="#">2</a></li>                                            
                                            <li class="px-1"><a href="#">3</a></li>
                                            <li class="px-1"><a href="#">4</a></li>  
                                            <li class="px-1"><a href="#">5</a></li>                                            
                                            <li class="px-1"><a href="#"><i class="fa fa-angle-double-right" aria-hidden="true"></i></a></li>       
                                        </ul>
                                    </div>
                                </div>
                            </div>
                           
        
</React.Fragment>

        )
    
}
export default EmployerDashboard

